function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.59 13.923l-.008.062c-1.833-.913-2.025-1.035-2.261-.68-.164.246-.643.804-.787.969-.146.162-.29.175-.538.062-.25-.125-1.053-.387-2.003-1.237-.74-.663-1.236-1.475-1.383-1.725-.244-.422.267-.482.732-1.362.083-.175.04-.312-.021-.437-.063-.125-.56-1.35-.768-1.838-.2-.487-.406-.425-.56-.425-.48-.042-.831-.035-1.14.287-1.345 1.478-1.006 3.003.145 4.625 2.261 2.96 3.466 3.505 5.67 4.261.595.19 1.137.163 1.566.101.479-.076 1.473-.6 1.68-1.188.213-.588.213-1.075.15-1.188-.061-.112-.225-.175-.475-.287z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 4.875C12.692-1.32 2.088 3.173 2.084 11.91c0 1.747.458 3.45 1.33 4.954L2 22l5.28-1.376c6.587 3.558 14.717-1.167 14.72-8.708a9.828 9.828 0 00-2.913-7.009l.013-.032zm1.235 7.014c-.005 6.36-6.988 10.333-12.51 7.086l-.3-.178-3.125.813.837-3.038-.199-.313C1.602 10.79 5.55 3.64 12.06 3.64c2.212 0 4.287.862 5.85 2.425a8.157 8.157 0 012.425 5.825z",
    fill: props.color
  }));
};
SvgWhatsapp.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgWhatsapp.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgWhatsapp;